export default __webpack_public_path__ + "resources/icons/d440-fd87.png";